var selected_value = 0;
var orderId, orderUuidFromView;
let vendorId;

const toFiniteNumber = (value) => {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : null;
};

const isValidLatLng = (lat, lng) =>
  Number.isFinite(lat) &&
  Number.isFinite(lng) &&
  lat >= -90 &&
  lat <= 90 &&
  lng >= -180 &&
  lng <= 180;

const firstFinite = (...values) => {
  for (const value of values) {
    if (Number.isFinite(value)) return value;
  }
  return null;
};

const geocodeAddress = (address) =>
  new Promise((resolve) => {
    if (!address || !window.google || !google.maps || !google.maps.Geocoder) {
      resolve(null);
      return;
    }
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address }, (results, status) => {
      if (status === "OK" && results && results[0] && results[0].geometry) {
        const loc = results[0].geometry.location;
        resolve({ lat: loc.lat(), lng: loc.lng() });
        return;
      }
      resolve(null);
    });
  });

const buildAddressLine = (addressObj) => {
  if (!addressObj) return "";
  const parts = [
    addressObj.Address_Line_1,
    addressObj.Landmark,
    addressObj.City,
    addressObj.State,
    addressObj.Pincode,
  ]
    .map((v) => (v || "").toString().trim())
    .filter((v) => v.length > 0);
  return parts.join(", ");
};

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const waitForGoogleMaps = async (timeoutMs = 10000, intervalMs = 250) => {
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    if (
      window.google &&
      google.maps &&
      google.maps.Map &&
      google.maps.Marker &&
      google.maps.Polyline &&
      google.maps.LatLng &&
      google.maps.LatLngBounds
    ) {
      return true;
    }
    await sleep(intervalMs);
  }
  return false;
};

const getCurrentPositionSafe = () =>
  new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(null);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) =>
        resolve({
          lat: toFiniteNumber(position.coords.latitude),
          lng: toFiniteNumber(position.coords.longitude),
        }),
      () => resolve(null),
      { timeout: 6000, maximumAge: 30000, enableHighAccuracy: false },
    );
  });

export default class customerConfirmationPage {
  constructor() {
    this.ratingbtn = $(".ratingBtnConfirmPage");
    this.inputReviewStarRatingError = $(".vendorRatingErrorMsg");
    this.submitVendorRating = $(".submitVendorRatingBtn");
    this.reloadOrderFlowBtn = $(".reloadOrderFlowBtn");

    $(".confirmationPageOrderRatingSection").hide();

    orderUuidFromView = $(".Order_ID").val();
    orderId = orderUuidFromView; // Set global orderId to the UUID from view

    //this.getOrderId()
    //add " <?php echo ($data) ?> " to php file

    //Registering Events
    this.bindEvents();
  }

  bindEvents = () => {
    this.ratingbtn.on("click", this.btnrating);
    this.submitVendorRating.on("click", this.submitreviewCheck);

    //Calling order details on load
    $(window).on("load", () => { this.getOrderDetails(); });
    //Automatic refresh orderFlow
    //setInterval(this.showOrderFlow, 120000);

    // setInterval(this.showOrderFlow, 20000);
    this.reloadOrderFlowBtn.on("click", this.showOrderFlow);

    //close buttons
    $(".reviewConfirmationpageClose").on("click", () => {
      $("#reviewConfirmationpage").hide();
    });
  };

  //getting order details
  getOrderDetails = async () => {
    $.ajax({
      url: baseURL + "api/customer/Cart/OrderDetails",
      type: "POST",
      data: {
        Order_ID: orderUuidFromView,
      },
      headers: { Authorization: X_API_KEY },
      success: async (res) => {
        //setting orderID
        orderId = res.Order.Order_ID;

        await this.showOrderFlow();
        //setting vendorID
        vendorId = res.Vendor_details.Vendor_ID;
        var additionalVendorDetails = "";

        if (res.Vendor_details.Business_Name.length > 30) {
          var vname = res.Vendor_details.Business_Name.substring(0, 28) + "...";
        } else {
          var vname = res.Vendor_details.Business_Name;
        }

        var bookedtime = res.Order.Order_booked_date_time.split(" ")[1];
        bookedtime = bookedtime.substring(0, 5);

        var currentOrderStatus = res.Order.Order_Status;
        currentOrderStatus = currentOrderStatus.toLowerCase();

        if (
          currentOrderStatus == "enquiry cancelled" ||
          currentOrderStatus == "enquiry received"
        ) {
        } else {
          additionalVendorDetails = `
          <p class="text-muted ml-1 mb-1"><strong>Phone</strong> : ${res.Vendor_details.Phone_Number}</p>
          <p class="text-muted ml-1 line-clamp-4 mb-0 readmoreVendorAddress"><strong>Seller Address</strong> : ${res.Order.Vendor_Address_Details}</p>
          <p class="text-muted ml-1 mb-1 readmoreVendorAddressButton"><u>Read more...</u></p>
          `;
        }

        //self pickup redirection button
        //res.Delivery.Delivery_Name.toLowerCase() == "self pickup" &&
        if (
          res.Order.Order_Status.toLowerCase() != "enquiry received" &&
          res.Order.Order_Status.toLowerCase() != "enquiry cancelled"
        ) {
          const dirLat = firstFinite(
            toFiniteNumber(res.Order?.Vendor_Address_Lat),
            toFiniteNumber(res.Vendor_address_details?.lat),
            toFiniteNumber(res.Vendor_address_details?.Latitude),
            toFiniteNumber(res.Vendor_details?.lat),
            toFiniteNumber(res.Vendor_details?.Latitude),
          );
          const dirLon = firstFinite(
            toFiniteNumber(res.Order?.Vendor_Address_Lon),
            toFiniteNumber(res.Vendor_address_details?.lon),
            toFiniteNumber(res.Vendor_address_details?.lng),
            toFiniteNumber(res.Vendor_address_details?.Longitude),
            toFiniteNumber(res.Vendor_details?.lon),
            toFiniteNumber(res.Vendor_details?.lng),
            toFiniteNumber(res.Vendor_details?.Longitude),
          );

          if (isValidLatLng(dirLat, dirLon)) {
            $(".getDirections").removeClass("d-none");
            $(".getDirections").off("click").on("click", () => {
              window.location = `https://www.google.com/maps/dir/?api=1&destination=${dirLat},${dirLon}`;
            });
          } else {
            $(".getDirections").addClass("d-none");
          }
        } else {
          $(".getDirections").addClass("d-none");
        }

        //vendor details
        $(".vendorDetailsConfirmationPage").empty();
        $(".vendorDetailsConfirmationPage").append(
          `<div class="row">
          <div class="card-body pb-0">
              <div class="row">
                  <div class="col-8 ml-2 d-flex justify-content-start">
                      <p class="text-muted">#ENQUIRY ${res.Order.Order_No}</p>
                  </div>
                  <div class="col d-flex justify-content-end">
                      <h6 class="btn card-title orderHelp">HELP</h6>
                  </div>
              </div>
              <h5 class=" ml-1 card-text truncate-cart pl-1">${vname}</h5>
              ${additionalVendorDetails}
              <hr>
              <p class="text-muted ml-1 line-clamp-4 mb-0 readmoreCustomerAddress"><strong>Customer Address</strong> : ${res.Order.Customer_Address_Details}</p>
          <p class="text-muted ml-1 mb-1 readmoreCustomerAddressButton"><u>Read more...</u></p>
              <div class="row">
                  <div class="col ml-2 pr-0 d-flex justify-content-start pt-1">
                      <p class="text-muted">${bookedtime} | ${res.Order_products.length}item | ₹${res.Order.Final_Bill_Amount}</p>
                  </div>
                  <div class="col pl-0 d-flex justify-content-end">

                      <span class="cancelOrderBtnWrapper">
                        <h6 class="btn cancelOrderBtn">CANCEL ENQUIRY</h6>
                      </span>

                  </div>
              </div>
          </div>
      </div>`,
        );
        $(".cancelOrderBtn").on("click", this.cancelOrder);
        $(".orderHelp").on("click", this.orderHelp);

        $(".readmoreCustomerAddressButton").on("click", () => {
          $(".readmoreCustomerAddress").removeClass("line-clamp-4");
          $(".readmoreCustomerAddressButton").addClass("d-none");
        });

        if (additionalVendorDetails != "") {
          $(".readmoreVendorAddressButton").on("click", () => {
            $(".readmoreVendorAddress").removeClass("line-clamp-4");
            $(".readmoreVendorAddressButton").addClass("d-none");
          });
        }

        const statusLower = (res?.Order?.Order_Status || "").toLowerCase();
        if (!statusLower.includes("cancel")) {
          this.renderMapWithRetry(res);
        } else {
          $("#mapAddressForOrderConfirmationPage").html(
            `<p class="text-muted mb-0">Map unavailable for this order.</p>`,
          );
        }
      },
      error: (err) => {},
    });
  };

  //cancel order
  cancelOrder = async () => {
    $.ajax({
      url: baseURL + "api/customer/Cart/OrderCancel",
      type: "POST",
      data: {
        Order_ID: orderId,
      },
      headers: { Authorization: X_API_KEY },
      success: async (res) => {
        await this.getOrderDetails();
        await this.showOrderFlow();
      },
      error: (err) => {},
    });
  };

  //help with order
  orderHelp = async () => {
    //setting session cookies
    $.ajax({
      url: baseURL + "api/customer/CustomerCookies/setSessionId",
      type: "POST",
      data: {
        data: { HELP_REQUESTED: orderId },
      },
      success: (res) => {
        window.location = baseURL + `customer/account`;
      },
      error: (err) => {},
    });
  };

  //submit button for review
  vendorRatingSubmit = async () => {
    $.ajax({
      url: baseURL + "api/customer/Cart/VendorRating",
      type: "POST",
      data: {
        Order_ID: orderId,
        Vendor_ID: vendorId,
        ReviewScore: selected_value,
      },
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        $("#reviewConfirmationpage").show();
      },
      error: (err) => {},
    });
  };

  submitreviewCheck = (e) => {
    e.preventDefault();
    let isReviewStarRatingValidated = this.ReviewRating_validate();
    if (isReviewStarRatingValidated) {
      this.inputReviewStarRatingError.html("");
      this.vendorRatingSubmit();
    }
  };

  btnrating = (event) => {
    var previous_value = $("#vRatingConfirmPage").val();

    //

    selected_value = $(event.currentTarget).attr("data-attrr");

    $("#vRatingConfirmPage").val(selected_value);

    $(".vRatingConfirmPage").empty();
    $(".vRatingConfirmPage").html(selected_value);

    for (var i = 1; i <= selected_value; ++i) {
      $("#rating-" + i).toggleClass("text-default");
      $("#rating-" + i).toggleClass("text-warning");
    }

    for (var ix = 1; ix <= previous_value; ++ix) {
      $("#rating-" + ix).toggleClass("text-default");
      $("#rating-" + ix).toggleClass("text-warning");
    }
  };

  ReviewRating_validate = () => {
    let flag = true;
    if (selected_value == 0) {
      this.inputReviewStarRatingError.html("Select rating");
      flag = false;
    }
    return flag;
  };

  renderMapWithRetry = async (order) => {
    const maxAttempts = 4;
    const retryDelayMs = 1200;

    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      const isGoogleReady = await waitForGoogleMaps(8000);
      if (!isGoogleReady) {
        if (attempt < maxAttempts) {
          await sleep(retryDelayMs);
          continue;
        }
        break;
      }

      try {
        const rendered = await this.showMap(order);
        if (rendered) return;
      } catch (err) {
        console.error("Map render attempt failed:", err);
      }

      if (attempt < maxAttempts) {
        await sleep(retryDelayMs);
      }
    }

    $("#mapAddressForOrderConfirmationPage").html(
      `<p class="text-muted mb-0">Map unavailable for this order.</p>`,
    );
  };

  drawRouteMap = (customerLat, customerLng, vendorLat, vendorLng) => {
    $("#mapAddressForOrderConfirmationPage").empty();

    const customer = { lat: customerLat, lng: customerLng };
    const vendor = { lat: vendorLat, lng: vendorLng };

    const pos1 = new google.maps.LatLng(customerLat, customerLng);
    const pos2 = new google.maps.LatLng(vendorLat, vendorLng);
    const bounds = new google.maps.LatLngBounds();
    bounds.extend(pos1);
    bounds.extend(pos2);

    const map = new google.maps.Map(
      document.getElementById("mapAddressForOrderConfirmationPage"),
      {
        zoom: 12,
        scaleControl: true,
        center: bounds.getCenter(),
      },
    );

    //customer marker
    const iconForCustomer = {
      url: "https://img.icons8.com/color/48/null/order-delivered.png",
    };
    //vendor marker
    const iconForVendor = {
      url: "https://img.icons8.com/color/48/null/small-business.png",
    };

    new google.maps.Marker({
      position: customer,
      map: map,
      icon: iconForCustomer,
    });
    new google.maps.Marker({
      position: vendor,
      map: map,
      icon: iconForVendor,
    });

    // Keep existing straight dotted route style.
    const lineSymbol = {
      path: "M 0,-1 0,1",
      strokeOpacity: 1,
      scale: 4,
    };
    new google.maps.Polyline({
      path: [customer, vendor],
      strokeOpacity: 0,
      icons: [
        {
          icon: lineSymbol,
          offset: "0",
          repeat: "20px",
        },
      ],
      map: map,
    });

    map.fitBounds(bounds);
  };

  showMap = async (order) => {
    var vendorAddress = order.Vendor_address_details;
    var deliveryDetails = order.Delivery;
    const deliveryType = deliveryDetails?.Delivery_Type || "";
    var customerAddress = order.Order;
    var customerAddressDetails = order.customerAddress;
    var vendorDetails = order.Vendor_details;

    let vendorLat = firstFinite(
      toFiniteNumber(vendorAddress?.lat),
      toFiniteNumber(vendorAddress?.Latitude),
      toFiniteNumber(vendorDetails?.lat),
      toFiniteNumber(vendorDetails?.Latitude),
      toFiniteNumber(customerAddress?.Vendor_Address_Lat),
    );
    let vendorLng = firstFinite(
      toFiniteNumber(vendorAddress?.lon),
      toFiniteNumber(vendorAddress?.lng),
      toFiniteNumber(vendorAddress?.Longitude),
      toFiniteNumber(vendorDetails?.lon),
      toFiniteNumber(vendorDetails?.lng),
      toFiniteNumber(vendorDetails?.Longitude),
      toFiniteNumber(customerAddress?.Vendor_Address_Lon),
    );

    const vendorAddressText =
      customerAddress?.Vendor_Address_Details || buildAddressLine(vendorAddress);
    const customerAddressText =
      customerAddress?.Customer_Address_Details ||
      buildAddressLine(customerAddressDetails);

    if (!isValidLatLng(vendorLat, vendorLng)) {
      const vendorGeo = await geocodeAddress(vendorAddressText);
      if (vendorGeo) {
        vendorLat = vendorGeo.lat;
        vendorLng = vendorGeo.lng;
      }
    }

    // Current Location Marker for self pickup - TODO LATER
    let customerLat = null;
    let customerLng = null;

    if (deliveryType == "None") {
      const currentPosition = await getCurrentPositionSafe();
      customerLat = toFiniteNumber(currentPosition?.lat);
      customerLng = toFiniteNumber(currentPosition?.lng);
    } else {
      customerLat = firstFinite(
        toFiniteNumber(customerAddress?.Customer_Address_Lat),
        toFiniteNumber(customerAddressDetails?.lat),
        toFiniteNumber(customerAddressDetails?.Latitude),
      );
      customerLng = firstFinite(
        toFiniteNumber(customerAddress?.Customer_Address_Lon),
        toFiniteNumber(customerAddressDetails?.lon),
        toFiniteNumber(customerAddressDetails?.lng),
        toFiniteNumber(customerAddressDetails?.Longitude),
      );
    }

    if (!isValidLatLng(customerLat, customerLng)) {
      customerLat = firstFinite(
        toFiniteNumber(customerAddress?.Customer_Address_Lat),
        toFiniteNumber(customerAddressDetails?.lat),
        toFiniteNumber(customerAddressDetails?.Latitude),
      );
      customerLng = firstFinite(
        toFiniteNumber(customerAddress?.Customer_Address_Lon),
        toFiniteNumber(customerAddressDetails?.lon),
        toFiniteNumber(customerAddressDetails?.lng),
        toFiniteNumber(customerAddressDetails?.Longitude),
      );
    }

    if (!isValidLatLng(customerLat, customerLng)) {
      const customerGeo = await geocodeAddress(customerAddressText);
      if (customerGeo) {
        customerLat = customerGeo.lat;
        customerLng = customerGeo.lng;
      }
    }

    if (!isValidLatLng(vendorLat, vendorLng)) {
      const vendorGeo = await geocodeAddress(vendorAddressText);
      if (vendorGeo) {
        vendorLat = vendorGeo.lat;
        vendorLng = vendorGeo.lng;
      }
    }

    if (
      !isValidLatLng(customerLat, customerLng) ||
      !isValidLatLng(vendorLat, vendorLng)
    ) {
      return false;
    }

    this.drawRouteMap(customerLat, customerLng, vendorLat, vendorLng);
    return true;
  };

  showOrderFlow = async () => {
    $(".orderFlowScrollSection").empty();
    $.ajax({
      url: baseURL + "api/customer/Cart/OrderDetails",
      type: "POST",
      data: {
        Order_ID: orderId,
      },
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        var order = res;

        var orderStatusDetails = order.Order_Status_Details;

        var orderDeliveryDetails = order.Delivery;
        var styleHeight = 31;

        orderStatusDetails.forEach((status) => {
          if (status.Order_Status == "ORDER DELIVERED") {
            styleHeight = 23;
          } else if (status.Order_Status == "ORDER PICKED UP") {
            styleHeight = 23;
          }
        });

        var orderFlowContent = `<div id="here" class="overflow-auto cpScroll orderStatusFlowScrollSection" style="height: ${styleHeight}rem;">
    <div class="card shadow-sm mb-5 orderStatusFlowItems">
        <div class="row ">
            <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
                <i class="fa-solid fa-circle-check fa-3x pl-4"></i>
            </div>
            <div class="col-8 col-lg-9">
                <div class="card-body pl-0">
                    <div class="row">
                        <div class="d-flex justify-content-start">
                            <h5 class="card-title">ENQUIRY RECEIVED :</h5>
                        </div>
                    </div>
                    <p class="card-text truncate-cart">AWAITING THE SELLER TO ACCEPT ENQUIRY.</p>
                </div>
            </div>
        </div>
    </div>
</div>`;

        $(".orderFlowScrollSection").append(orderFlowContent);

        var orderFlowRSKM = [
          "ENQUIRY RECEIVED",
          "ENQUIRY ACCEPTED",
          "ORDER READY",
          "ORDER OUT FOR DELIVERY",
          "ORDER DELIVERED",
        ];
        var orderFlowSPU = [
          "ENQUIRY RECEIVED",
          "ENQUIRY ACCEPTED",
          "ORDER READY",
          "ORDER PICKED UP",
        ];

        var lastStatus = "";
        var cancelled = 0;
        orderStatusDetails.forEach((status) => {
          var description = "";
          var orderStatusItem = "";
          if (status.Order_Status == "ENQUIRY ACCEPTED") {
            description = "THE SELLER HAS ACCEPTED THE ENQUIRY.";
            orderStatusItem = `<div class="hr-sect m-0">GC</div>
        <div class="row">
        <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
            <i class="fa-solid fa-circle-check fa-3x pl-4"></i>
        </div>
        <div class="col-8 col-lg-9">
            <div class="card-body pl-0">
                <div class="row">
                    <div class="d-flex justify-content-start">
                        <h5 class="card-title">${status.Order_Status} : </h5>
                    </div>
                </div>
                <p class="card-text truncate-cart">${description}</p>
            </div>
        </div>
    </div>`;
            $(".confirmationPageOrderRatingSection").hide();
            $(".cancelOrderBtnWrapper").html(
              `<h6 class="btn text-secondary">CANCEL ENQUIRY</h6>`,
            );
          } else if (status.Order_Status == "ORDER READY") {
            description = "YOUR ORDER IS READY.";
            orderStatusItem = `<div class="hr-sect m-0">GC</div>
        <div class="row">
        <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
            <i class="fa-solid fa-circle-check fa-3x pl-4"></i>
        </div>
        <div class="col-8 col-lg-9">
            <div class="card-body pl-0">
                <div class="row">
                    <div class="d-flex justify-content-start">
                        <h5 class="card-title">${status.Order_Status} : </h5>
                    </div>
                </div>
                <p class="card-text truncate-cart">${description}</p>
            </div>
        </div>
    </div>`;
            $(".confirmationPageOrderRatingSection").hide();
          } else if (status.Order_Status == "ORDER OUT FOR DELIVERY") {
            description = "YOUR ORDER IS OUT FOR DELIVERY.";
            orderStatusItem = `<div class="hr-sect m-0">GC</div>
        <div class="row">
        <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
            <i class="fa-solid fa-circle-check fa-3x pl-4"></i>
        </div>
        <div class="col-8 col-lg-9">
            <div class="card-body pl-0">
                <div class="row">
                    <div class="d-flex justify-content-start">
                        <h5 class="card-title">${status.Order_Status} : </h5>
                    </div>
                </div>
                <p class="card-text truncate-cart">${description}</p>
            </div>
        </div>
    </div>`;
            $(".confirmationPageOrderRatingSection").hide();
          } else if (status.Order_Status == "ORDER DELIVERED") {
            description = "YOUR ORDER HAS BEEN DELIVERED.";
            orderStatusItem = `<div class="hr-sect m-0">GC</div>
        <div class="row">
        <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
            <i class="fa-solid fa-circle-check fa-3x pl-4"></i>
        </div>
        <div class="col-8 col-lg-9">
            <div class="card-body pl-0">
                <div class="row">
                    <div class="d-flex justify-content-start">
                        <h5 class="card-title">${status.Order_Status} : </h5>
                    </div>
                </div>
                <p class="card-text truncate-cart">${description}</p>
            </div>
        </div>
    </div>`;
            $(".confirmationPageOrderRatingSection").show();
          } else if (status.Order_Status == "ORDER PICKED UP") {
            description = "YOUR ORDER WAS PICKED UP.";
            orderStatusItem = `<div class="hr-sect m-0">GC</div>
        <div class="row">
        <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
            <i class="fa-solid fa-circle-check fa-3x pl-4"></i>
        </div>
        <div class="col-8 col-lg-9">
            <div class="card-body pl-0">
                <div class="row">
                    <div class="d-flex justify-content-start">
                        <h5 class="card-title">${status.Order_Status} : </h5>
                    </div>
                </div>
                <p class="card-text truncate-cart">${description}</p>
            </div>
        </div>
    </div>`;

            $(".confirmationPageOrderRatingSection").show();
          } else if (status.Order_Status == "ENQUIRY RECEIVED") {
            description = "AWAITING THE SELLER TO ACCEPT ENQUIRY.";
          }

          $(".confirmationPageOrderConfirmationMsg").html(
            `${status.Order_Status} : ${description}`,
          );
          $(".orderStatusFlowItems").append(orderStatusItem);

          lastStatus = status.Order_Status;
        });

        if (lastStatus == "ENQUIRY CANCELLED BY CUSTOMER") {
          $(".cancelOrderBtnWrapper").html(
            `<h6 class="btn text-secondary">CANCEL ENQUIRY</h6>`,
          );
          var description = "YOU HAVE CANCELLED THIS ENQUIRY.";
          var orderStatusItem = `<div class="hr-sect m-0">GC</div>
        <div class="row">
        <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
            <i class="fa-solid fa-circle-check fa-3x pl-4"></i>
        </div>
        <div class="col-8 col-lg-9">
            <div class="card-body pl-0">
                <div class="row">
                    <div class="d-flex justify-content-start">
                        <h5 class="card-title">ENQUIRY CANCELLED</h5>
                    </div>
                </div>
                <p class="card-text truncate-cart">${description}</p>
            </div>
        </div>
    </div>`;

          $(".confirmationPageOrderConfirmationMsg").html(
            `ENQUIRY CANCELLED : ${description}`,
          );
          $(".orderStatusFlowItems").append(orderStatusItem);
          $(".confirmationPageOrderRatingSection").hide();
        } else if (lastStatus == "ENQUIRY CANCELLED BY SELLER") {
          $(".cancelOrderBtnWrapper").html(
            `<h6 class="btn text-secondary">CANCEL ENQUIRY</h6>`,
          );
          description = "THE SELLER HAS CANCELLED THE ENQUIRY.";
          orderStatusItem = `<div class="hr-sect m-0">GC</div>
        <div class="row">
        <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
            <i class="fa-solid fa-circle-check fa-3x pl-4"></i>
        </div>
        <div class="col-8 col-lg-9">
            <div class="card-body pl-0">
                <div class="row">
                    <div class="d-flex justify-content-start">
                        <h5 class="card-title">ENQUIRY CANCELLED</h5>
                    </div>
                </div>
                <p class="card-text truncate-cart">${description}</p>
            </div>
        </div>
    </div>`;

          $(".confirmationPageOrderConfirmationMsg").html(
            `ENQUIRY CANCELLED : ${description}`,
          );
          $(".orderStatusFlowItems").append(orderStatusItem);
          $(".confirmationPageOrderRatingSection").hide();
        } else {
          if (
            orderDeliveryDetails.Delivery_Type == "RSKM" ||
            orderDeliveryDetails.Delivery_Type == "KM"
          ) {
            var index = orderFlowRSKM.indexOf(lastStatus);

            for (var i = index + 1; i < orderFlowRSKM.length; i++) {
              var description = "";
              var orderStatusItem = "";
              if (orderFlowRSKM[i] == "ENQUIRY ACCEPTED") {
                description = "THE SELLER HAS ACCEPTED THE ENQUIRY.";
                orderStatusItem = `<div class="hr-sect m-0">GC</div>
            <div class="row">
            <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
            <i class="fa-regular fa-hourglass fa-2x pl-4"></i>
            </div>
            <div class="col-8 col-lg-9">
                <div class="card-body pl-0">
                    <div class="row">
                        <div class="d-flex justify-content-start">
                            <h5 class="card-title">${orderFlowRSKM[i]} : </h5>
                        </div>
                    </div>
                    <p class="card-text truncate-cart">${description}</p>
                </div>
            </div>
        </div>`;
              } else if (orderFlowRSKM[i] == "ORDER READY") {
                description = "YOUR ORDER IS READY.";
                orderStatusItem = `<div class="hr-sect m-0">GC</div>
            <div class="row">
            <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
            <i class="fa-regular fa-hourglass fa-2x pl-4"></i>
            </div>
            <div class="col-8 col-lg-9">
                <div class="card-body pl-0">
                    <div class="row">
                        <div class="d-flex justify-content-start">
                            <h5 class="card-title">${orderFlowRSKM[i]} : </h5>
                        </div>
                    </div>
                    <p class="card-text truncate-cart">${description}</p>
                </div>
            </div>
        </div>`;
              } else if (orderFlowRSKM[i] == "ORDER OUT FOR DELIVERY") {
                description = "YOUR ORDER IS OUT FOR DELIVERY.";
                orderStatusItem = `<div class="hr-sect m-0">GC</div>
            <div class="row">
            <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
            <i class="fa-regular fa-hourglass fa-2x pl-4"></i>
            </div>
            <div class="col-8 col-lg-9">
                <div class="card-body pl-0">
                    <div class="row">
                        <div class="d-flex justify-content-start">
                            <h5 class="card-title">${orderFlowRSKM[i]} : </h5>
                        </div>
                    </div>
                    <p class="card-text truncate-cart">${description}</p>
                </div>
            </div>
        </div>`;
              } else if (orderFlowRSKM[i] == "ORDER DELIVERED") {
                description = "YOUR ORDER HAS BEEN DELIVERED.";
                orderStatusItem = `<div class="hr-sect m-0">GC</div>
            <div class="row">
            <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
            <i class="fa-regular fa-hourglass fa-2x pl-4"></i>
            </div>
            <div class="col-8 col-lg-9">
                <div class="card-body pl-0">
                    <div class="row">
                        <div class="d-flex justify-content-start">
                            <h5 class="card-title">${orderFlowRSKM[i]} : </h5>
                        </div>
                    </div>
                    <p class="card-text truncate-cart">${description}</p>
                </div>
            </div>
        </div>`;
              }
              $(".orderStatusFlowItems").append(orderStatusItem);
            }
          } else if (orderDeliveryDetails.Delivery_Type == "None") {
            var index = orderFlowSPU.indexOf(lastStatus);

            for (var i = index + 1; i < orderFlowSPU.length; i++) {
              var description = "";
              var orderStatusItem = "";
              if (orderFlowSPU[i] == "ENQUIRY ACCEPTED") {
                description = "THE SELLER HAS ACCEPTED THE ENQUIRY.";
                orderStatusItem = `<div class="hr-sect m-0">GC</div>
            <div class="row">
            <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
            <i class="fa-regular fa-hourglass fa-2x pl-4"></i>
            </div>
            <div class="col-8 col-lg-9">
                <div class="card-body pl-0">
                    <div class="row">
                        <div class="d-flex justify-content-start">
                            <h5 class="card-title">${orderFlowSPU[i]} : </h5>
                        </div>
                    </div>
                    <p class="card-text truncate-cart">${description}</p>
                </div>
            </div>
        </div>`;
              } else if (orderFlowSPU[i] == "ORDER READY") {
                description = "YOUR ORDER IS READY.";
                orderStatusItem = `<div class="hr-sect m-0">GC</div>
            <div class="row">
            <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
            <i class="fa-regular fa-hourglass fa-2x pl-4"></i>
            </div>
            <div class="col-8 col-lg-9">
                <div class="card-body pl-0">
                    <div class="row">
                        <div class="d-flex justify-content-start">
                            <h5 class="card-title">${orderFlowSPU[i]} : </h5>
                        </div>
                    </div>
                    <p class="card-text truncate-cart">${description}</p>
                </div>
            </div>
        </div>`;
              } else if (orderFlowSPU[i] == "ORDER PICKED UP") {
                description = "YOUR ORDER HAS BEEN PICKED UP";
                orderStatusItem = `<div class="hr-sect m-0">GC</div>
            <div class="row">
            <div class="col-4 col-lg-3 d-flex justify-content-center align-items-center">
            <i class="fa-regular fa-hourglass fa-2x pl-4"></i>
            </div>
            <div class="col-8 col-lg-9">
                <div class="card-body pl-0">
                    <div class="row">
                        <div class="d-flex justify-content-start">
                            <h5 class="card-title">${orderFlowSPU[i]} : </h5>
                        </div>
                    </div>
                    <p class="card-text truncate-cart">${description}</p>
                </div>
            </div>
        </div>`;
              }
              $(".orderStatusFlowItems").append(orderStatusItem);
            }
          }
        }
      },
      error: (err) => {},
    });
  };
}

